// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"7c9d3d23","213":"f87269e0","417":"553a4197","420":"4e62fe3d","448":"af8648dc","566":"8e8447c1","586":"876fa73b","631":"496974f1","664":"5ccb2b26","908":"3d535cf5","910":"048a9b2f","972":"cc679f26","984":"89c2e926"}[chunkId] + ".chunk.js";
};